module.exports = __webpack_public_path__ + "img/bg-2.8806aa6f.png";